import { defineAbility, type RawRuleOf, type MongoAbility } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue'
import type { App } from 'vue'

export type AppAbility = MongoAbility<[string, string]>

export const ability = defineAbility<AppAbility>(() => {})

/**
 * Обновить ability — вызывается из useAuthStore после login/me.
 * Правила приходят с бэка (`abilities` в /auth/me) — единый источник правды.
 */
export function setAbilities(rules: RawRuleOf<AppAbility>[]) {
  ability.update(rules)
}

export function installCasl(app: App) {
  app.use(abilitiesPlugin, ability, { useGlobalProperties: true })
}
